export default __webpack_public_path__ + "static/media/hexagon.d655f3d8.svg";